import { useMemo } from 'react';
//Hook para sanitizar dados, substituindo valores nulos, indefinidos ou vazios por um valor padrão.
export const useSanitizeData = (
    data,
    fallback = 'Não Informado(a)'
) => {
    return useMemo(() => {
        if (!Array.isArray(data)) return [];

        const sanitizeValue = (value) => {
            if (
                value === null ||
                value === undefined ||
                value === 'NULL'
            ) {
                return fallback;
            }

            return value;
        };

        const sanitizeObject = (obj) => {
            return Object.entries(obj).reduce((acc, [key, value]) => {
                acc[key] = sanitizeValue(value);
                return acc;
            }, {});
        };

        return data.map(sanitizeObject);
    }, [data, fallback]);
};